module.exports = [{
      plugin: require('../node_modules/gatsby-v2-plugin-page-transitions/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Funnel Crashkurs","short_name":"Funnel Crashkurs","start_url":"/","background_color":"white","theme_color":"#007aff","display":"standalone","icon":"static/icon.png","include_favicon":true},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
